import React from 'react';
import { Box, VStack, Heading, Text } from '@chakra-ui/react';

interface LoginImageBandProps {
  title: string;
  imagepath: string;
}

const LoginImageBand: React.FC<LoginImageBandProps> = ({ title, imagepath }) => {
  return (
    <Box
      as="section"
      height="25vh"
      bgImage={imagepath}
      bgSize="cover"
      bgPos="center"
      position="relative"
    >
      {/* Semi-transparent overlay */}
      <Box
        position="absolute"
        top="0"
        left="0"
        width="100%"
        height="100%"
        bg="rgba(0, 0, 0, 0.3)"
        zIndex="1"
      />

      <VStack
        justifyContent="center"
        alignItems="center"
        height="100%"
        zIndex="2"
        position="relative"
        spacing={4}
      >
        <Heading color="white" size="2xl">{title}</Heading>
      </VStack>
    </Box>
  );
};

export default LoginImageBand;
